const SUBSECTION_NAME_PREFIX = "[subsection] ";
const SUBSECTION_NAME_SEPARATOR = " || ";
const CATEGORY_NAME_PREFIX = "[category] ";

export const parseVorlageName = (value) => {
  const rawName = String(value || "").trim();

  if (!rawName.startsWith(SUBSECTION_NAME_PREFIX)) {
    return {
      rawName,
      displayName: rawName,
      subsection: "",
      category: "",
      regionName: rawName,
      hasSubsection: false,
    };
  }

  const encoded = rawName.slice(SUBSECTION_NAME_PREFIX.length);
  const separatorIndex = encoded.indexOf(SUBSECTION_NAME_SEPARATOR);
  if (separatorIndex === -1) {
    return {
      rawName,
      displayName: rawName,
      subsection: "",
      category: "",
      regionName: rawName,
      hasSubsection: false,
    };
  }

  const subsection = encoded.slice(0, separatorIndex).trim();
  const remainder = encoded.slice(separatorIndex + SUBSECTION_NAME_SEPARATOR.length).trim();
  let category = "";
  let displayName = remainder;

  if (remainder.startsWith(CATEGORY_NAME_PREFIX)) {
    const categoryEncoded = remainder.slice(CATEGORY_NAME_PREFIX.length);
    const categorySeparatorIndex = categoryEncoded.indexOf(SUBSECTION_NAME_SEPARATOR);
    if (categorySeparatorIndex !== -1) {
      category = categoryEncoded.slice(0, categorySeparatorIndex).trim();
      displayName = categoryEncoded.slice(categorySeparatorIndex + SUBSECTION_NAME_SEPARATOR.length).trim();
    }
  }

  if (!subsection || !displayName) {
    return {
      rawName,
      displayName: rawName,
      subsection: "",
      category: "",
      regionName: rawName,
      hasSubsection: false,
    };
  }

  return {
    rawName,
    displayName,
    subsection,
    category,
    regionName: subsection,
    hasSubsection: true,
  };
};

export const buildVorlageName = ({ name, subsection, category }) => {
  const normalizedName = String(name || "").trim();
  const normalizedSubsection = String(subsection || "").trim();
  const normalizedCategory = String(category || "").trim();

  if (!normalizedSubsection) return normalizedName;
  if (!normalizedName) return "";

  if (!normalizedCategory) {
    return `${SUBSECTION_NAME_PREFIX}${normalizedSubsection}${SUBSECTION_NAME_SEPARATOR}${normalizedName}`;
  }

  return `${SUBSECTION_NAME_PREFIX}${normalizedSubsection}${SUBSECTION_NAME_SEPARATOR}${CATEGORY_NAME_PREFIX}${normalizedCategory}${SUBSECTION_NAME_SEPARATOR}${normalizedName}`;
};

export const getVorlageDisplayName = (entry) => parseVorlageName(entry?.name).displayName;

export const getVorlageSubsection = (entry) => parseVorlageName(entry?.name).subsection;

export const getVorlageCategory = (entry) => parseVorlageName(entry?.name).category;

export const getVorlageRegionName = (entry) => parseVorlageName(entry?.name).regionName;

export const getVorlageActualRegion = (entry) => parseVorlageName(entry?.name).displayName;

export const hasVorlageSubsection = (entry) => parseVorlageName(entry?.name).hasSubsection;

export const ensureModalitaetenVorlagen = (list, defaults) => {
  const existing = Array.isArray(list) ? list : [];
  const defaultList = Array.isArray(defaults) ? defaults : [];
  const byKey = new Set(existing.map((entry) => `${entry?.mod || ""}::${entry?.name || ""}`));
  const missingDefaults = defaultList.filter(
    (entry) => !byKey.has(`${entry.mod}::${entry.name}`)
  );

  return {
    merged: [...existing, ...missingDefaults],
    missingDefaults,
  };
};

export const mapBaselineVorlageRow = (row, createId) => ({
  id: String(row?.id || row?.prompt_id || createId()),
  name: String(row?.name || ""),
  mod: String(row?.mod || "CT"),
  befund: String(row?.befund || ""),
  beurteilung: row?.beurteilung || null,
  created_at: row?.created_at || Date.now(),
});

export const resolvePromptTargetMod = (promptMod, promptMrtTarget) => (
  promptMod === "MRT" ? promptMrtTarget : promptMod
);
